import type { CustomIconProps } from '../CustomIcon';

export const SSNIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 44,
  ...props
}: CustomIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 44 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <rect width={44} height={44} rx={10} fill='#2F444F' />
    <path fill='#66C4CE' d='M17 14h15v3H17zM22 18h15v3H22zM12 22h14.858v2.857H12zM6 26h15v3H6z' />
  </svg>
);
